export const WITHDRAWAL_STATUS: Record<
  string,
  { label: string; color: "default" | "info" | "success" | "warning" | "error" }
> = {
  pending: { label: "Ожидает выполнения", color: "warning" },
  completed: { label: "Выполнена", color: "success" },
  rejected: { label: "Отклонена", color: "error" },
  cancelled: { label: "Отменена клиентом", color: "default" },
};

export function withdrawalStatus(status: string): {
  label: string;
  color: "default" | "info" | "success" | "warning" | "error";
} {
  return WITHDRAWAL_STATUS[status] ?? { label: status, color: "default" };
}
